import { render, staticRenderFns } from "./Prognosen.vue?vue&type=template&id=55941949&"
import script from "./Prognosen.vue?vue&type=script&lang=js&"
export * from "./Prognosen.vue?vue&type=script&lang=js&"
import style0 from "./Prognosen.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports